import { action } from 'mobx';
import {
  DeepSearchService,
  DeepSearchStore as Store
} from 'modules/userManager';

const filterCount = 'accessFilterCount';

class AccessService {
  @action
  updateFieldValue(field, option, fields) {
    const fieldValue = Store.deepSearch.accessFilter[field];

    if (field !== fields.userPlusAccess) {
      this.updateStoreCount(field, option, fields);

      if (field === fields.accessPlusAll) {
        fieldValue.value = option ? option.value : '';
      }

      fieldValue.query = option ? option.value : '';
    } else {
      fieldValue.value = option ? option.value : '';
    }
  }

  @action
  updateStoreCount(field, option, fields) {
    const fieldValue = Store.deepSearch.accessFilter[field];
    let shouldIncrement = option && option.value;
    let shouldDecrement = fieldValue.query;

    if (field === fields.accessPlusAll) {
      shouldIncrement = !fieldValue.value;
      shouldDecrement = option && !option.value;
    }

    DeepSearchService.updateFilterCount(
      shouldIncrement,
      shouldDecrement,
      filterCount
    );
  }

  @action
  updateSelectFieldsStore(option, field, fields) {
    Store.deepSearch.accessFilter[field].option = option ? option : '';
    this.updateFieldValue(field, option, fields);
  }

  @action
  updateDateFieldData(field, option, dateFilterType, from, until) {
    const { accessFilter } = Store.deepSearch;
    const rangeDate = { from, until };
    const resetField = {
      _type: Store.deepSearch.accessFilter[field]._type,
      value: '',
      option: {},
      dateFilterType: ''
    };
    const newValue = {
      ...Store.deepSearch.accessFilter[field],
      option: { ...option, ...rangeDate },
      dateFilterType,
      from,
      until
    };

    Object.assign(accessFilter[field], option.value ? newValue : resetField);
  }
}

export default new AccessService();
